// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-content[data-v-c30d652e]{display:flex;flex-direction:column;width:100%;max-width:760px;margin:0 auto;padding:40px 0 80px}", ""]);
// Exports
module.exports = exports;
